import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3846c52a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mt-3 mb-2 font-bold text-[14px]" }, "Información personal", -1))
const _hoisted_2 = { class: "flex flex-col gap-2" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_4 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_5 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-bold text-[14px] mt-3 mb-2" }, "Información adicional", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "grid grid-cols-2 gap-2"
}
const _hoisted_9 = { class: "font-bold text-[14px] mt-3 mb-2 text-red-500" }
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Selector = _resolveComponent("Selector")!
  const _component_NewModal = _resolveComponent("NewModal")!

  return (_openBlock(), _createBlock(_component_NewModal, {
    title: "Registro de nuevo usuario",
    visible: _ctx.visible,
    "onUpdate:visible": _cache[11] || (_cache[11] = (e) => _ctx.$emit('update:visible', e))
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_TextField, {
            class: "col-span-2 lg:col-span-1",
            model: _ctx.firstName,
            "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstName) = $event)),
            type: "text",
            name: "firstName",
            label: "Nombres",
            "has-error": _ctx.firstNameFieldHasError,
            "error-message": "Este campo es requerido",
            "hide-details": ""
          }, null, 8, ["model", "has-error"]),
          _createVNode(_component_TextField, {
            class: "col-span-2 lg:col-span-1",
            model: _ctx.lastName,
            "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event)),
            type: "text",
            name: "lastName",
            "has-error": _ctx.lastNameFieldHasError,
            "error-message": "Este campo es requerido",
            label: "Apellidos",
            "hide-details": ""
          }, null, 8, ["model", "has-error"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_TextField, {
            class: "col-span-2 lg:col-span-1",
            model: _ctx.rut,
            "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rut) = $event)),
            type: "text",
            name: "rut",
            label: "Rut",
            "has-error": _ctx.rutFieldHasError,
            "error-message": "Este campo es requerido y debe ser un rut válido. No debe contar con puntos pero si con guión y número verificador (Ej: 12345678-9)",
            "hide-details": ""
          }, null, 8, ["model", "has-error"]),
          _createVNode(_component_Selector, {
            class: "col-span-2 lg:col-span-1",
            model: _ctx.gender,
            "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.gender) = $event)),
            items: ['Mujer', 'Hombre'],
            label: "Genero",
            "has-error": _ctx.genderFieldHasError,
            "error-message": "Debe indicar si el representante o el accionista es hombre o mujer. Será utilizado como referencia para la generación de contratos."
          }, null, 8, ["model", "has-error"])
        ]),
        _createVNode(_component_TextField, {
          model: _ctx.address,
          "onUpdate:model": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.address) = $event)),
          type: "text",
          name: "address",
          label: "Dirección particular",
          "has-error": _ctx.addressFieldHasError,
          "error-message": "Debe ingresar la dirección del cliente",
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createVNode(_component_TextField, {
          model: _ctx.region,
          "onUpdate:model": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.region) = $event)),
          type: "text",
          name: "region",
          label: "Región",
          "has-error": _ctx.regionFieldHasError,
          "error-message": "Debe ingresar la región del cliente",
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createVNode(_component_TextField, {
          model: _ctx.county,
          "onUpdate:model": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.county) = $event)),
          type: "text",
          name: "county",
          label: "Comuna",
          "has-error": _ctx.countyFieldHasError,
          "error-message": "Debe ingresar la comuna del cliente",
          "hide-details": ""
        }, null, 8, ["model", "has-error"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_TextField, {
            class: "col-span-2 lg:col-span-1",
            model: _ctx.email,
            "onUpdate:model": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.email) = $event)),
            type: "text",
            name: "email",
            label: "Correo eléctronico",
            "has-error": _ctx.emailFieldHasError,
            "error-message": "Es necesario ingresar un correo electrónico valido.",
            "hide-details": ""
          }, null, 8, ["model", "has-error"]),
          _createVNode(_component_TextField, {
            class: "col-span-2 lg:col-span-1",
            model: _ctx.phone,
            "onUpdate:model": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.phone) = $event)),
            type: "number",
            name: "phone",
            label: "Teléfono",
            "hide-details": ""
          }, null, 8, ["model"])
        ])
      ]),
      _hoisted_6,
      _createVNode(_component_TextField, {
        model: _ctx.password,
        "onUpdate:model": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.password) = $event)),
        type: "text",
        name: "password",
        label: "Contraseña temporal",
        "has-error": _ctx.passwordFieldHasError,
        "error-message": "La contraseña debe tener un minimo de 6 caracteres",
        "hide-details": ""
      }, null, 8, ["model", "has-error"]),
      _hoisted_7,
      (_ctx.textError != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.textError), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "success btn ml-auto",
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.registerShareholder && _ctx.registerShareholder(...args))),
        disabled: _ctx.formHasError
      }, " Registrar ", 8, _hoisted_10)
    ]),
    _: 1
  }, 8, ["visible"]))
}